/* eslint-disable */
import React, { useEffect, useRef } from 'react';
import { useCookies } from 'react-cookie';

const API_URL = import.meta.env.VITE_API_URL;

function Token() {
  const [cookies, setCookie] = useCookies(['token']);
  
  // ใช้ useRef ป้องกันการยิงซ้ำ
  const hasFetched = useRef(false);

  useEffect(() => {
    if (cookies.token) {
      hasFetched.current = false;
      return;
    }
    if (hasFetched.current) return;

    const fetchToken = async () => {
      hasFetched.current = true;
      try {
        const myHeaders = new Headers();
        myHeaders.append("Authorization", "Basic SHJAYm9vbnNpcmkuY28udGg6SHJAYnNyISEh");
        
        const requestOptions = {
          method: "GET",
          headers: myHeaders,
          redirect: "follow"
        };
        
        const response = await fetch(`${API_URL}/getAuthToken`, requestOptions);
        const result = await response.json();
        
        if (result.access_token) {
          const expirationDate = new Date(Date.now() + 50 * 60 * 1000); // 50 นาที
          
          setCookie('token', result.access_token, { 
            path: '/', 
            expires: expirationDate
          });
        } else {
          hasFetched.current = false;
        }
      } catch (error) {
        console.error("Error fetching auth token:", error);
        hasFetched.current = false; // Reset เพื่อให้ลองใหม่ได้ถ้า Error
      }
    };

    fetchToken();
    
  }, [cookies.token, setCookie]);
    
  return null;
}

export default Token;